import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import Button from 'components/button';


const InvalidModal = ({ isVisible, setIsVisible, rejectReasons, capex, errorMessages }) => {
  // console.log('rejectReasons: ', rejectReasons)
  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      // title={'Αδύνατη υποβολή αίτησης'}
      // handleConfirm={() => setVisible(false)}
      onCancel={() => setIsVisible(false)}
      width={400}
      footer={[
        <Button
          label={'Κλείσιμο'}
          type={'default'}
          onClick={() => setIsVisible(false)}
        />,
      ]}
      className={'invalid-modal'}
    >
      {capex && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <WarningRed></WarningRed>
          </div>
          <div className="invalid-modal__body">
            {Object.values(errorMessages)?.map((message, index) => (
              <p key={index}>{message}</p>
            ))}
          </div>
        </>
      }

      {rejectReasons?.case === "checkUniqueness" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Δημιουργίας Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            {rejectReasons.responseCode === "901" &&
             <p>Η δημιουργία αίτησης δεν είναι εφικτή καθώς υπάρχει ενεργή αίτηση με το ίδιο ΑΦΜ.</p>}
          </div>
        </>
      }
      {rejectReasons?.case === "thirdPartyValidations" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Υποβολής Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            <h4>Η αίτησή σας απορρίφθηκε, καθώς:</h4>
            {!rejectReasons.isGreekAfm && <p>δεν είναι Ελληνικό Α.Φ.Μ.</p> }
            {!rejectReasons.isActive && <p>δεν είναι ενεργή κατά την ημερομηνία υποβολής της αίτησης Χρηματοδότησης από το Πρόγραμμα.</p> }
            {rejectReasons.responseCode === "901" && <p>υπάρχει ήδη ενεργή αίτηση με αυτό το ΑΦΜ.</p>}
            {rejectReasons.responseCode === "902" && <p>έχετε ήδη λάβει επιδότηση μέσω της δράσης Super-FastBroadband (SFBB).</p>}
            {rejectReasons.responseCode === "903" && <p>το αίτημα δεν είναι αποδεκτό λόγω μη επιλέξιμου ΚΑΔ.</p>}
            {rejectReasons.responseCode === "904" && <p>ο ΑΦΜ έχει υπερβεί το όριο κρατικών ενισχύσεων μέσω του προγράμματος «Smart Readiness»</p>}
            {rejectReasons.responseCode === "905" && <p>υπάρχει ήδη ενεργή αίτηση στον ίδιο Αριθμό Τηλεφωνικής Σύνδεσης</p>}

          </div>
        </>
      }
    </Modal>
  );
};

export default InvalidModal;
